import React from "react";
import {Form,Button,Card,Container,Row,Col} from "react-bootstrap";
import { useUsuarioSistema } from '../hooks/useUsuarioSistema';
import DataTable from "react-data-table-component";

import { useContext,useState ,useEffect} from "react";
import { AuthContext } from "auth";
import { useListaMaestra } from "hooks/useListaMaestra";
import {excelExport} from "../utils/excelExport";

function ListaMaestra() {
    
    var {user}= useContext(AuthContext)
    let usuario=user.Usuario;
    const usuarioActualSistema = useUsuarioSistema({Usuario:usuario,Genero:'F',CargoId:1});
    const [columns, setColumns] = useState([]);
    const [loading, setLoading] = useState(true);
    const {  getListaMaestraDatos,columnasListaMaestraDatos,listaMaestraDatos} = useListaMaestra();

    useEffect(() => {
      console.log('useEffect1')
      const loadTableData = async () => {
        await getListaMaestraDatos();
        setLoading(true);
        setLoading(false);
        return;
      };
  
      loadTableData();
    }, []);
      // Estado para manejar los checkboxes seleccionados (por fila y columna)
  //const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  
    useEffect(() => {
      console.log('useEffect2')
      const loadTableData = async () => {
        setLoading(true);

        const dynamicColumns = [
         /* {
            name: "Nombre",
            selector: (row) => row.NombreSocial,
            sortable: true,
            width: '200px',
          },
          {
            name: "Rut",
            selector: (row) => row.Rut,
            sortable: true,
          },*/
          ...columnasListaMaestraDatos.map((d) => ({
            name: d.Nombre,
            selector: (row) => row[d.Codigo],
            ignoreRowClick: true, 
            allowOverflow: true,
            button: true,
            width: '200px', 
          })),
         
        ];
        setColumns(dynamicColumns);
        setLoading(false);

      };
  
      loadTableData();
    }, [columnasListaMaestraDatos]);
    return (
      <>
        <Container fluid>
          
        <Row>
            <Col md="12">
              <Card className="strpied-tabled-with-hover">
                <Card.Header>
                  <Card.Title as="h4">Lista Maestra</Card.Title>
                  <p className="card-category">
                    En esta sección se puede visualizar lista maestra
                  </p>
                </Card.Header>
                <Card.Body className="table-full-width table-responsive px-0">
                <div className="pull-right ml-3">
                <Form>
                 
                  <DataTable
                    columns={columns}
                    data={listaMaestraDatos}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                    persistTableHead
                    paginationPerPage={50}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]} 
                 
                  /> 
                </Form>
               
                <Button
                  className="btn-fill pull-right ml-2"
                  type="info"
                  variant="reset"
                  onClick={() => excelExport(columns, listaMaestraDatos,'ListaMaestra')}
                  > <i className="fas fa-file-excel"></i> Exportar a Excel</Button>
                 
                
                </div>
                </Card.Body>
              </Card>
            </Col>
        </Row>
        </Container>
      </>
    );
}
export default ListaMaestra;